import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AdminMission } from '../models/mission-admin';

@Injectable({
  providedIn: 'root',
})
export class MissionAdminService {
  private readonly baseUrl = `${environment.apiUrl}/missions/`;

  constructor(private http: HttpClient) {}

  list(params?: { search?: string; game?: string; tier?: number; is_active?: string | boolean; page?: number }): Observable<any> {
    let httpParams = new HttpParams();
    
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          httpParams = httpParams.set(key, String(value));
        }
      });
    }
    
    return this.http.get<any>(this.baseUrl, {
      params: httpParams,
    });
  }

  detail(missionId: number): Observable<AdminMission> {
    return this.http.get<AdminMission>(`${this.baseUrl}${missionId}/`);
  }

  create(payload: Partial<AdminMission>): Observable<AdminMission> {
    return this.http.post<AdminMission>(this.baseUrl, payload);
  }

  update(missionId: number, payload: Partial<AdminMission>): Observable<AdminMission> {
    return this.http.patch<AdminMission>(`${this.baseUrl}${missionId}/`, payload);
  }

  deactivate(missionId: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}${missionId}/`);
  }
}